import React, { ReactNode, useRef } from "react";
import { _colorText, _sizeText } from "../../core/core";
import { Text } from "../texts/text";
import "./InputNew.css";

export type InputNewStyle = "default" | "inverse";
export interface InputNewProps extends React.InputHTMLAttributes<HTMLInputElement> {
    labelOutside?: string | ReactNode;
    error?: string;
    color?: InputNewStyle;
    icon_left?: React.ReactNode;
    icon_right?: React.ReactNode;
}

export const InputNew = React.forwardRef<HTMLInputElement, InputNewProps>(
    ({ error, value, placeholder, disabled, color = "default", labelOutside, icon_left, icon_right, type = "text", ...props }, ref) => {
        const hasValue = Boolean(value);
        const internalRef = useRef<HTMLInputElement>(null);

        // Используем переданный ref или внутренний
        const inputRef = ref || internalRef;

        const handlePrivateClick = (e: React.MouseEvent<HTMLInputElement>) => {
            if (inputRef && typeof inputRef === 'object' && inputRef.current) {
                inputRef.current.focus();
                console.log(inputRef.current);
            }
            console.log(inputRef);
            e.preventDefault();
            e.stopPropagation();
        }
        const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
            e.preventDefault();
            e.stopPropagation();
            const text = e.clipboardData.getData('text');
            if (props.onChange) {
                props.onChange({
                    target: {
                        value: text
                    }
                } as React.ChangeEvent<HTMLInputElement>);
            }
        }
        const handleClear = () => {
            if (props.onChange) {
                props.onChange({
                    target: {
                        value: ''
                    }
                } as React.ChangeEvent<HTMLInputElement>);
            }
        }
        return (
            <div className={`input-new__wrapper${disabled ? " input-new--disabled" : ""}${error ? " input-new--error" : ""}${hasValue ? " input-new--filled" : ""}`.trim()}>

                {labelOutside && (
                    <Text size={_sizeText.xs} color={_colorText.neutral}>
                        {labelOutside}
                    </Text>
                )}
                <div onClick={handlePrivateClick} className={`input-new__field input-new__field-${color}`}>
                    {icon_left && <div className="input-new__icon-left">{icon_left}</div>}
                    <div className={`input-new__field-group input-type-g__${type}`}>
                        {placeholder && hasValue && <label className="input-new__label">{placeholder}</label>}
                        <input
                            ref={inputRef}
                            className={`input-new__input input-type__${type}`}
                            type={type}
                            placeholder={placeholder}
                            value={value}
                            disabled={disabled}
                            onPaste={handlePaste}
                            {...props}
                        />
                    </div>
                    {icon_right && <div className="input-new__icon-right">{icon_right}</div>}
                    {props.onChange && hasValue && !disabled && (
                        <button type="button" className="input-new__clear" onClick={handleClear} tabIndex={-1} aria-label="Очистить поле">
                            ×
                        </button>
                    )}
                </div>

                {error && <Text color={_colorText.negative}>{error}</Text>}
            </div>
        );
    }
);InputNew.displayName = "InputNew";